// extracted by mini-css-extract-plugin
export default {"productCarousel":"v0-z"};